@if (initialized) {
    <div class="grid">
        <div class="col-12">
            @if (activeNavigationItem.action === 'editor') {
                <div class="flex flex-column gap-3">
                    <!--
                      A mapping logic has no script — neither the syntax check nor the script save has
                      anything to act on. The FK is persisted by the picker itself.
                    -->
                    @if (!isMappingLanguage()) {
                        <div style="margin-left: auto;">
                            <div class="flex gap-3">
                                <p-button icon="fa-regular fa-circle-check" styleClass="p-button-outlined" label="Syntax prüfen" (click)="checkSyntax()"></p-button>
                                <p-button icon="fa-regular fa-floppy-disk" label="Speichern" (click)="updateScript()"></p-button>
                            </div>
                        </div>
                    }
                    <div class="lg-logic-side-editor">

                        @if (isMappingLanguage()) {
                            <!-- The mapping language has no script: the FK to the table IS the configuration. -->
                            <mvs-lg-mapping-table-select
                                    [logicDto]="dto"
                                    (mappingTableChange)="onMappingTableChanged($event)">
                            </mvs-lg-mapping-table-select>
                        } @else if (isFormatLanguage()) {
                            <!-- TM-1000001726: structured Format-Function editor replaces CodeMirror. -->
                            <mvs-format-script-editor
                                    [script]="script"
                                    [variables]="importVariableNames"
                                    (scriptChange)="onFormatScriptChange($event)">
                            </mvs-format-script-editor>
                        } @else if (isModuleFunctionLanguage()) {
                            <!-- TM-1000001726 Phase 2: structured Module-Function editor replaces CodeMirror. -->
                            <mvs-module-function-script-editor
                                    [script]="script"
                                    [variables]="importVariableNames"
                                    (scriptChange)="onModuleFunctionScriptChange($event)">
                            </mvs-module-function-script-editor>
                        } @else if (isCrudLanguage()) {
                            <!-- TM-1000001726 Phase 3: structured CRUD-Script editor replaces CodeMirror. -->
                            <mvs-crud-script-editor
                                    [script]="script"
                                    [variables]="importVariableNames"
                                    (scriptChange)="onCrudScriptChange($event)">
                            </mvs-crud-script-editor>
                        } @else {
                            <mvs-code-mirror-editor
                                    [editorContent]="script"
                                    [logicLanguage]="dto.logicLanguage"
                                    (contentChanged)="onContentChange($event)"
                                    (onLogicLanguageChanged)="handleLogicLanguageChange($event)"
                            ></mvs-code-mirror-editor>
                        }

                    </div>
                    <ng-container *ngIf="syntaxResponse">
                        <div class="bg-black-alpha-90 p-2 border-round mt-2">
                            <div class="pb-3 pt-2 px-2 text-white font-bold">
                                Syntax-Ergebnis
                            </div>
                            <div class="bg-white py-2">
                                @for (error of syntaxResponse?.errors; track error) {

                                    <div class="text-red-500 p-2">
                                        <i class="fa-solid fa-circle-exclamation"></i> {{ error }}
                                    </div>
                                }

                                @for (warning of syntaxResponse?.warnings; track warning) {

                                    <div class="text-yellow-500 p-2">
                                        <i class="fa-solid fa-triangle-exclamation"></i> {{ warning }}
                                    </div>
                                }
                            </div>

                        </div>

                    </ng-container>
                </div>
            }
            @if (activeNavigationItem.action === 'variablen') {
                <div class="flex flex-column gap-4">
                    <mvs-lg-variables
                            [variableProviderService]="logicImportService"
                            alias="lg.LogicImport"
                            attributeName="variableName"
                            title="Importe"
                            [contentProviderId]="dto.id"
                    ></mvs-lg-variables>
                    <mvs-lg-variables
                            [variableProviderService]="logicExportService"
                            alias="lg.LogicExport"
                            attributeName="name"
                            title="Exporte"
                            [contentProviderId]="dto.id"
                    ></mvs-lg-variables>
                </div>
            }
            @if (activeNavigationItem.action === 'testen') {
                <mvs-lg-test-case [screen]="'sm'" [logicId]="objectIdentifier.objectId"></mvs-lg-test-case>
            }
            @if (activeNavigationItem.action === 'mappings') {
                <mvs-lg-logic-mappings [logicDto]="dto"></mvs-lg-logic-mappings>
            }
            @if (activeNavigationItem.action === 'quickTest') {
                <mvs-lg-logic-quick-test
                        [logicId]="objectIdentifier.objectId"
                        [logicDto]="dto"></mvs-lg-logic-quick-test>
            }

        </div>

    </div>
}
